export default "__VITE_ASSET__DkYtDI4l__"